import React, { Component } from 'react';
import { connect, Provider } from 'react-redux';
import upcomingEvent from '../page/UpcomingEventPage';
import store from '../configureStore';
import * as settingsActions from '../actions/settings';

const mapStateToProps = ({ settings }) => ({
  ...settings,
  timeZone: window.bta.timeZone,
  xPropMode: window.xprops.data.mode,
  onTrigger: window.xprops.onTrigger,
});

const UpcomingEvent = connect(
  mapStateToProps,
  null,
)(upcomingEvent);

export default class UpcomingEventWidgetContainer extends Component {
  UNSAFE_componentWillMount() {
    const { settings, defaultSetting, defaultTranslation, exceededTrialPlan } = this.props;
    store.dispatch(
      settingsActions.setConfiguration({
        ...settings,
        defaultSetting,
        defaultTranslation,
        exceededTrialPlan
      }),
    );
  }

  componentDidMount() {
    const { settings } = this.props;
    if (window.xprops && window.xprops.onInit) {
      window.xprops.onInit(settings.setting);
    }
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <UpcomingEvent {...this.props} />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = value => store.dispatch(settingsActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingsActions.setTranslation(key, value));
};
window.changeSetting = (key, value) => store.dispatch(settingsActions.setSetting(key, value));
